export enum ErrorClass {
    user,
    developer,
    it
}

export enum ErrorZone {
    dropzone,
    invoice_list,
    pdf_viewer,
    application
}